<ng-template #loadingGeneral>

  <mat-spinner class="center"></mat-spinner>
  <h4 class="center">Loading...</h4>

</ng-template>

<mat-card appearance="outlined" fxLayout="column" *ngIf="!loading else loadingGeneral">
  <mat-card-header>
    <mat-card-title>{{company?.companyName}}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-list>
      <mat-list-item>
        <h3>
          <strong>Address:</strong>
          {{company?.companyAddress}}
        </h3>
      </mat-list-item>
      <mat-list-item>
        <h3>
          <strong>E-mail:</strong>
          {{company?.companyEmail}}
        </h3>
      </mat-list-item>
      <mat-list-item *ngIf="company?.contact1email">
        <h3>
          <strong>Contact E-mail 1:</strong>
          {{company?.contact1email}}
        </h3>
      </mat-list-item>
      <mat-list-item *ngIf="company?.contact1phone">
        <h3>
          <strong>Contact Phone 1: </strong>
          {{company?.contact1phone}}
        </h3>
      </mat-list-item>
      <mat-list-item *ngIf="company?.contact1role">
        <h3>
          <strong>Contact Role 1:</strong>
          {{company?.contact1role}}
        </h3>
      </mat-list-item>
      <mat-list-item *ngIf="company?.contact2email">
        <h3>
          <strong>Contact E-mail 2:</strong>
          {{company?.contact2email}}
        </h3>
      </mat-list-item>
      <mat-list-item *ngIf="company?.contact2phone">
        <h3>
          <strong>Contact Phone 2:</strong>
          {{company?.contact2phone}}
        </h3>
      </mat-list-item>
      <mat-list-item *ngIf="company?.contact2role">
        <h3>
          <strong>Contact Role 2:</strong>
          {{company?.contact2role}}
        </h3>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>